import React from 'react';

import { FadeEdge, OverlaysRoot } from './styled';

export { ScrollSentinel } from './styled';

type ScrollFadeOverlaysProps = {
  showTop: boolean;
  showBottom: boolean;
};

const ScrollFadeOverlays: React.FC<ScrollFadeOverlaysProps> = ({
  showTop,
  showBottom,
}) => (
  <OverlaysRoot aria-hidden>
    <FadeEdge $side="top" $visible={showTop} />
    <FadeEdge $side="bottom" $visible={showBottom} />
  </OverlaysRoot>
);

export default ScrollFadeOverlays;
